import type { ReactNode} from 'react';
import React, { useContext as useContextCore } from 'react'

export type ToastContextType = {
  showToast: (options?: ShowToastOptions) => void
  showError: (options?: Omit<ShowToastOptions, 'type'>) => void
  showSuccess: (options?: Omit<ShowToastOptions, 'type'>) => void
  showInfo: (options?: Omit<ShowToastOptions, 'type'>) => void
  showWarning: (options?: Omit<ShowToastOptions, 'type'>) => void
  showNotification: (message: string) => void
}

export type ShowToastOptions = {
  type?: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'dark' | 'light' | 'default'
  message: string | ReactNode
  title?: string
  readonly show?: boolean
}

export const ToastContext = React.createContext<ToastContextType>({} as ToastContextType)

export const useToast = () => useContextCore(ToastContext)
